(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  function throttle(func, limit) {
    let inThrottle;
    return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    }
}

const limitedBannerPositions = {
    1394: 4,
    1327: 3,
    862: 3,
    0: 2
};

function moveBannerCollectionListElement() {
    const bannerElement = document.getElementById('collection-limited-banner');
    if (!bannerElement) {
        return;
    }
    const bannerCopy = bannerElement.cloneNode(true);
    const bannerParentList = bannerElement.parentNode;
    const currentWidth = window.innerWidth;

    bannerParentList.removeChild(bannerElement);

    const bannerPosition = getBannerPosition(currentWidth);

    if (bannerPosition === undefined || bannerPosition < 0) {
        console.error(`Invalid bannerPosition calculated: ${bannerPosition}`);
        return;
    }
    const referenceElement = bannerPosition < bannerParentList.children.length
        ? bannerParentList.children[bannerPosition]
        : null;
        
    console.log(`Moving banner to position: ${bannerPosition} (Reference: ${referenceElement ? referenceElement.id || referenceElement.tagName : 'end'})`);
    bannerParentList.insertBefore(bannerCopy, referenceElement);
}

function getBannerPosition(width) {
    const sortedKeys = Object.keys(limitedBannerPositions).sort((a, b) => b - a);

    for (const key of sortedKeys) {
        if (width >= parseInt(key, 10)) {
            return limitedBannerPositions[key];
        }
    }
    return limitedBannerPositions[0] !== undefined ? limitedBannerPositions[0] : 0;
}

document.addEventListener('DOMContentLoaded', () => {
    moveBannerCollectionListElement();
});
window.addEventListener('resize', ()=>{
  clearTimeout('resizeBannerTimeout');
  let resizeBannerTimeout = setTimeout(function() {
    moveBannerCollectionListElement();
  }, 750);
})


  } catch(e) { console.error(e); }
})();
})();
